module.exports = __webpack_public_path__ + "static/media/reader-survey-win-2k-banner-min.23dd333f.png";